module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!--打包价弹出框模板-->\r\n\r\n<div class="hli-package-confirm-wrap">\r\n	<!-- <p>\r\n		<span style="margin-right: 10px;">该产品为打包产品，需提供航班号</span>\r\n		<input type="text" style="width: 80px;padding: 0 5px;" class="hli-package-input" />\r\n		<span class="warning-info hidden">请输入正确的航班号</span>\r\n	</p> -->\r\n\r\n	<p style="line-height: 18px;margin-top: 20px;">该产品禁止在OTA（携程、艺龙、去哪儿、美团、飞猪等）各平台售卖，一经发现将终止与贵司合作并索取不低于2晚的赔付。请各位同行配合，谢谢！</p>\r\n\r\n	<p class="hli-package-btn-wrap">\r\n		<!-- <a href="' +
((__t = ( link )) == null ? '' : __t) +
'" target="_blank" class="hli-package-btn disabled">下一步</a> -->\r\n		<a href="' +
((__t = ( link )) == null ? '' : __t) +
'" target="_blank" class="hli-package-btn">下一步</a>\r\n	</p>\r\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelPriceUtil/templates/packageTmpl.ejs
// module id = 88
// module chunks = 1 2 3 6 10